import { cn } from "@/lib/utils";

/**
 * The leverage bar: filled to the percentage, destructive at or over the org's target, ticked at it.
 * The tick sits above the fill with a card-coloured edge, so it still shows once the fill passes it.
 */
export function LeverageMeter({
  percent,
  targetPercent,
}: {
  percent: number;
  targetPercent: number;
}) {
  const over = percent >= targetPercent;
  return (
    <div className="relative h-1 w-16 rounded-full bg-muted">
      <div
        className={cn(
          "absolute left-0 top-0 h-full rounded-full transition-all duration-300",
          over ? "bg-destructive" : "bg-primary"
        )}
        style={{ width: `${Math.min(percent, 100)}%` }}
      />
      <div
        data-testid="leverage-warn-tick"
        className="absolute -top-0.5 z-[1] h-1.5 w-0.5 rounded-sm bg-destructive/50 ring-1 ring-card"
        style={{ left: `${targetPercent}%` }}
      />
    </div>
  );
}
